export const lettersEN = {
  "There no individual spreadsheets to display": "There no individual spreadsheets to display",
  "New Spreadsheet": "New Spreadsheet",
  "Actions": "Actions",
  "Format Name": "Format Name",
  "Description": "Description",
  "Folder": "Folder",
  "Modified By": "Modified By",
  "Date Modified": "Date Modified",
  "Created By": "Created By",
  "Date Created": "Date Created",
  "Run Spreadsheet": "Run Spreadsheet",
  "Edit Spreadsheet": "Edit Spreadsheet",
  "Delete Spreadsheet": "Delete Spreadsheet",
  "Are you sure you want to delete the selected format?": "Are you sure you want to delete the selected format?",
  "Operation canceled": "Operation canceled",
  "Folder name cannot be empty": "Folder name cannot be empty",
  'Delete Letter': 'Delete Letter',
  'Delete': 'Delete',
  'Cancel': 'Cancel',
  'Letter Templates': 'Letter Templates',
  'Are you sure you want to delete a folder?': 'Are you sure you want to delete a folder?'
};